import React from 'react';
import { Modal, Box, Button, SpaceBetween, Alert } from '@cloudscape-design/components';

interface ImageModificationErrorModalProps {
  visible: boolean;
  onDismiss: () => void;
}

export const ImageModificationErrorModal: React.FC<ImageModificationErrorModalProps> = ({
  visible,
  onDismiss,
}) => {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header="Image Modification Not Allowed"
      footer={
        <Box float="right">
          <Button variant="primary" onClick={onDismiss}>
            OK
          </Button>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <Alert type="error" header="Images Cannot Be Modified">
          You attempted to add or remove images from the content. Images cannot be
          modified in translation mode.
        </Alert>
        <Box>
          <Box variant="strong">What happened:</Box>
          <Box padding={{ top: 'xs', left: 's' }}>
            <SpaceBetween size="xxs">
              <Box>• Your change has been reverted to preserve the original images</Box>
              <Box>• Only text content can be modified in translation mode</Box>
            </SpaceBetween>
          </Box>
        </Box>
        <Box>
          <Box variant="strong">What you can do:</Box>
          <Box padding={{ top: 'xs', left: 's' }}>
            <SpaceBetween size="xxs">
              <Box>• Edit the text content without changing images</Box>
              <Box>
                • If you need to modify images, please edit the question in the default
                language
              </Box>
            </SpaceBetween>
          </Box>
        </Box>
      </SpaceBetween>
    </Modal>
  );
};
